import { render, staticRenderFns } from "./Folders2.vue?vue&type=template&id=aa813cec&scoped=true"
import script from "./Folders2.vue?vue&type=script&lang=js"
export * from "./Folders2.vue?vue&type=script&lang=js"
import style0 from "./Folders2.vue?vue&type=style&index=0&id=aa813cec&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa813cec",
  null
  
)

export default component.exports